import { action, observable } from "mobx";
import { ModelBase } from "@shoothill/core";
import { ProjectStatusTypeDTO } from "Views/Project/ProjectStatusTypeModel";

export class AllProjectsReportModel extends ModelBase<AllProjectsReportModel, any> {
    // #region Constructors and Disposers
    // #endregion Constructors and Disposers

    // #region Constants and Defaults

    // #endregion Constants and Defaults

    // #region Properties

    @observable
    public reportType: string | null = "";

    // #endregion Properties

    // #region Actions

    @action
    public reset = () => {
        this.reportType = "";
    };

    @action
    public fromDto(dto: any): void {
        //this just iterates through every key assigning it to the model
        //Should only use if there is a direct mapping between dto and domain model
        //otherwise just map them yourself
        for (let key in dto) {
            if (dto.hasOwnProperty(key)) {
                if (this[key] instanceof Date) {
                    this[key] = new Date(dto[key]);
                } else {
                    this[key] = dto[key];
                }
            }
        }
    }

    public toDto(): void {}

    // #endregion Actions

    // #region Custom Validation

    // #endregion Business Logic
}

export interface AllProjectsReportRelatedResponseDTO {
    projectStatuses: ProjectStatusTypeDTO[];
}
